/* unplugin-vue-components disabled */import script from "./StatusUpdater.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusUpdater.vue?vue&type=script&setup=true&lang=js"

import "./StatusUpdater.vue?vue&type=style&index=0&id=f33bc37c&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f33bc37c"]])

export default __exports__